import {useMutation} from "@apollo/client";

import {GQL_STATUS_PAGE_QUERY, GQL_UPDATE_COMPONENT} from "@/lib/queries/statuspages.ts";
import {Component, ComponentStatus} from "@/lib/types/statuspages.ts";
import {getComponentStatus} from "@/pages/statuspages/tabs/components/componentsTable/subComponents/ComponentStatusCell.utils.tsx";
import ComponentStatusIcon from "@/pages/statuspages/tabs/components/ComponentStatusSelect/ComponentStatusIcon.tsx";
import ComponentStatusSelect from "@/pages/statuspages/tabs/components/ComponentStatusSelect/ComponentStatusSelect.tsx";

interface ComponentStatusCellProps {
  component: Component;
  statusPageID: number;
  componentStatuses: ComponentStatus[];
  variant?: "select" | "icon";
}

const ComponentStatusCell = ({
  statusPageID,
  componentStatuses,
  component,
  variant = "select",
}: ComponentStatusCellProps) => {
  const [updateComponent] = useMutation(GQL_UPDATE_COMPONENT, {
    refetchQueries: [GQL_STATUS_PAGE_QUERY],
  });

  if (variant === "icon" || component.is_group) {
    const status = getComponentStatus(component, componentStatuses);
    return (
      <span className="d-flex">
        <ComponentStatusIcon className="me-2" status={status!.value} />
      </span>
    );
  }

  const handleChange = async ({value}: ComponentStatus) => {
    await updateComponent({
      variables: {
        statusPageID: statusPageID,
        data: {
          id: component.id,
          group: component.group,
          service: component.service,
          name: component.name,
          status: value,
        },
      },
    });
  };
  return (
    <ComponentStatusSelect
      value={componentStatuses.find((c) => c.value === component.status)}
      name={component.name}
      onChange={(status) => (status ? handleChange(status) : undefined)}
      options={componentStatuses.filter((c) => c.is_operational)}
      isDisabled={false}
      menuPortalTarget={
        (document.querySelector(`div.outlet-container > div.content-container`) as HTMLElement) ?? document.body
      }
      menuPosition={"fixed"}
    />
  );
};

export default ComponentStatusCell;
